<template>
  <div style="width: 100%">
    <div
      style="
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      "
    >
      <div>大米智课企业数字化培训平台</div>
      <div>
        大米智课培训平台实现培训管理/学习管理等企业培训全流程数字化管理大米智课培训平台实现培训管理/学习管理等企业培训全流程数字化管理
      </div>
    </div>
    <div class="hello">
      <div class="helloTop">
        <div style="width: 100%">
          <div
            style="display: flex; justify-content: space-between; width: 100%"
          >
            <div
              v-for="(item, i) in item"
              :class="['Lunbo3_1', i == aa ? 'active' : '']"
              @mouseenter="aaa(i)"
            >
              <img
                v-if="i == aa"
                :src="item.imgs"
                alt=""
                style="width: 100px"
              />
              <img v-else :src="item.img" alt="" style="width: 100px" />
              <div style="font-size: 14px">{{ item.title }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="hello2">
      <div class="Lunbo3_2">
        <div class="Lunbo3_3">
          <img src="../assets/yidong/1.png" alt="" style="width: 360px" />
          <div
            style="
              display: flex;
              flex-direction: column;
              justify-content: space-between;
            "
          >
            <div style="font-size: 20px">随时随地开展学习</div>
            <div class="Lunbo3_5" style="">
              <img src="../assets/shouye/3.png" alt="" />
              <div>随时随地开展学习</div>
            </div>
            <div class="Lunbo3_5" style="">
              <img src="../assets/shouye/3.png" alt="" />
              <div>随时随地开开展学习</div>
            </div>
            <div class="Lunbo3_5" style="">
              <img src="../assets/shouye/3.png" alt="" />
              <div>随时随地开展学习</div>
            </div>
            <div class="one_7">
              <div class="one_8" @click="isOpen = !isOpen">
                <div>立即获取</div>
                <img src="../assets//数字人/Union@2x.png" alt="" />
              </div>
              <el-link
                target="_blank"
                href="https://affim.baidu.com/unique_49847201/chat?siteId=19538945&userId=49847201&siteToken=d938ff4f7bae9254e1d97e1fae316cf6"
              >
                <!-- <div class="one_9">
                  <div>立即咨询</div>
                  <img src="../assets/HelloWorld/tubiao/67.png" alt="" />
                </div> -->
              </el-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      item: [
        {
          title: 'OMO培训',
          img: require('../assets/数字人/444.png'),
          imgs: require('../assets/数字人/44.png'),
        },
        {
          title: 'OMO培训',
          img: require('../assets/数字人/Frame.png'),
          imgs: require('../assets/数字人/Frame-1.png'),
        },
        {
          title: 'OMO培训',
          img: require('../assets/数字人/444.png'),
          imgs: require('../assets/数字人/44.png'),
        },
        {
          title: 'OMO培训',
          img: require('../assets/数字人/Frame.png'),
          imgs: require('../assets/数字人/Frame-1.png'),
        },
        {
          title: 'OMO培训',
          img: require('../assets/数字人/444.png'),
          imgs: require('../assets/数字人/44.png'),
        },
        {
          title: 'OMO培训',
          img: require('../assets/数字人/Frame.png'),
          imgs: require('../assets/数字人/Frame-1.png'),
        },
      ],
      aa: 0,
    }
  },
  mounted() {},
  methods: {
    aaa(i) {
      this.aa = i
    },
  },
}
</script>

<style lang="scss" scoped>
.hello {
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 50px 0;

  .helloTop {
    width: 1200px;
    height: 100%;
    display: flex;
    justify-content: space-between;
  }
}
.hello2 {
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 50px 0;
}
.Lunbo3_2 {
  width: 1200px;
  height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.Lunbo3_3 {
  display: flex;
  // flex-direction: column;
  justify-content: center;
}
.Lunbo3_5 {
  display: flex;
  align-items: center;
}

.one_7 {
  display: flex;
}
.one_8 {
  margin: 0 40px 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer !important;
  font-size: 14px;
  color: #ffffff;
  width: 154px;
  height: 46px;
  background: linear-gradient(90deg, #eb6215 0%, #ebaf15 100%);

  img {
    height: 14px;
    margin: 0 0 0 6px;
  }
}
.one_9 {
  display: flex;
  width: 154px;

  color: #eb6415;
  font-size: 14px;
  height: 46px;
  border: 1px solid #eb6415;
  align-items: center;
  justify-content: center;
  img {
    margin: 2px 0 0;
    width: 22px;
  }
}
.Lunbo3_1 {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  color: #000;
  padding: 0 0 10px;
  border-bottom: 3px solid transparent;

  &.active {
    color: #e7534b;
    border-bottom: 3px solid #e7534b;
  }
}
</style>
